// TravelPreviewPage.js
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import TravelPreview from "../component/TravelPreview/TravelPreview";

function TravelPreviewPage({ travelDataFromUrl }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [travelData, setTravelData] = useState(null);

  useEffect(() => {
    // URL経由のデータが優先、なければ location.state
    const data = travelDataFromUrl || location.state;
    if (data) {
      setTravelData(data);
    }
  }, [travelDataFromUrl, location.state]);

  if (!travelData) {
    return null;
  }

  const handleEditClick = () => {
    navigate("/tabi-jaws/travel", { state: travelData });
  };

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#f5f5f5" }}>
      {/* 編集ボタン */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          p: 1,
        }}
      >
        <Button
          variant="contained"
          startIcon={<EditIcon />}
          onClick={handleEditClick}
          sx={{
            backgroundColor: "#ff6a00",
            ":hover": { backgroundColor: "#e55d00" },
          }}
        >
          編集する
        </Button>
      </Box>
      <TravelPreview travelData={travelData} />
    </Box>
  );
}

export default TravelPreviewPage;
